import React from 'react';
import styles from './style.module.css';

export default ({
    input,
    key,
    name = input.name ? input.name : 'range',
    onChange = input.onChange,
    defaultValue = "0"
} = {}) => (
        <input
            id={key}
            type='range'
            name={name}
            step='1'
            min='0'
            max='2'
            className={styles.range}
            onClick={onChange}
            onTouchEnd={onChange}
            defaultValue={defaultValue}
        />
);
